module.exports = __webpack_public_path__ + "static/media/announcement-post.71f48dcf.svg";